import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import 'hammerjs';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { StripeCheckoutModule } from 'ng-stripe-checkout';
import { TranslateModule } from '@ngx-translate/core';
import { AmazingTimePickerModule } from 'amazing-time-picker';

import { FuseSplashScreenService } from './core/services/splash-screen.service';
import { FuseConfigService } from './core/services/config.service';
import { FuseNavigationService } from './core/components/navigation/navigation.service';

import { AppStoreModule } from './store/store.module';
import { SharedModule } from './core/modules/shared.module';
import { GraphQLModule } from './graphQl.module';
import { FuseAppsModule } from './main/content/apps/apps.module';
import { FuseMainModule } from './main/main.module';

import { AppComponent } from './app.component';
import { SolutionEstimateUsersQueryService } from './main/content/apps/queryFiles/solutionEstimateUsers';

const appRoutes: Routes = [
    {
        path: 'apps',
        loadChildren: './main/content/apps/apps.module#FuseAppsModule'
    },
    {
        path: '**',
        redirectTo: '/login',
    },
];

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        StripeCheckoutModule,
        HttpClientModule,
        HttpModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(appRoutes, { useHash: true }),
        TranslateModule.forRoot(),
        NgbModule.forRoot(),
        AmazingTimePickerModule,

        AppStoreModule,
        SharedModule,
        GraphQLModule,
        FuseAppsModule,
        FuseMainModule,
    ],
    providers: [
        FuseSplashScreenService,
        FuseConfigService,
        FuseNavigationService,
        SolutionEstimateUsersQueryService
    ],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/app.module.ts